export const STORAGE_KEY_INITIAL_IS_IN_TRIAL = 'postCheckout:isInTrial';

export const CEFR_CURRICULUM = 'CEFR';

export const CEFR_LEVELS: readonly string[] = ['A1', 'A2', 'B1', 'B2', 'C1', 'C2'];
